import React from 'react';
import ReactPlayer from 'react-player';
import Modal from '../../../../../components/Modal';
import './VideoViewModal.scss';

const VideoViewModal = (props) => {
  const { isOpen, closeModal, data } = props;
  const { url } = data;

  return (
    <Modal
      title="영상 미리 보기"
      onClose={() => closeModal()}
      isOpen={isOpen}
      width={500}
      height={320}
      isFooter={true}
      onOk={() => closeModal()}
    >
      <div className="video-view-modal">
        <ReactPlayer className="react-player" width={470} height={280} controls={true} url={url} />
      </div>
    </Modal>
  );
};

export default VideoViewModal;
